var animadoAlAparecer = function (selector, retardo) {
    if (retardo === void 0) { retardo = 150; }
    var elementos = [].slice.call(document.querySelectorAll(selector));
    var observer = new IntersectionObserver(function (datos) {
        var espera = 0;
        datos
            .filter(function (x) { return x.isIntersecting; })
            .forEach(function (_a) {
            var target = _a.target;
            var retardoDeElemento = parseInt(target.getAttribute('data-retardo') || retardo.toString(10));
            setTimeout(function () {
                target.classList.add('is-visible');
            }, espera += retardoDeElemento);
            observer.unobserve(target);
        });
    });
    var actualiza = function () {
        elementos = [].filter.call(document.querySelectorAll(selector), function (e) {
            return !e.classList.contains('is-visible');
        });
        elementos.forEach(function (elemento) { return observer.observe(elemento); });
    };
    actualiza();
    return {
        actualiza: actualiza
    };
};
export default animadoAlAparecer;
